import { Typography } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import * as React from 'react';
import { useController } from 'react-hook-form';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';

type Props = {
  name: string;
  label?: string;
  defaultValue?: string;
  options: (keyof typeof t)[] | string[];
  disabled?: boolean;
  onChange?: (name: string) => void;
};

const FormButtonSelect = ({ name, defaultValue, options, onChange, disabled, label }: Props) => {
  const { lang } = useLocale();
  const { field } = useController({ name, defaultValue });

  const handleChange = React.useCallback(
    (name: string) => {
      if (onChange && name !== field.value) {
        onChange(name);
      }
    },
    [field.value, onChange]
  );

  return (
    <>
      {label && (
        <Typography variant="body2" sx={{ color: (t) => t.palette.text.secondary, ml: 1, mb: 1 }}>
          {label}
        </Typography>
      )}
      <ToggleButtonGroup disabled={disabled} color="primary" exclusive fullWidth {...field}>
        {options.map((o) => (
          <ToggleButton
            onClick={() => handleChange(o)}
            sx={{ borderColor: (t) => t.palette.grey[400] }}
            color="secondary"
            key={o}
            value={o}
            fullWidth
          >
            {t[o as keyof typeof t]?.[lang] || o}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  );
};

export default FormButtonSelect;
